import { Outlet } from 'react-router-dom';
import { RafflesProvider } from './RafflesProvider';

export const RafflesLayout = () => {
  return (
    <RafflesProvider>
      <Outlet />
    </RafflesProvider>
  );
};
